import { Theme, styled } from '@material-ui/core';
import { forwardRef } from 'react';
import {
  NkInputError,
  NkInputLabel,
  getInputBorderColor,
  nkInputSize,
} from '../../shared/FormControls';
import { NkTextInputProps } from './NkTextInput.types';

export const NkTextInput = forwardRef<HTMLInputElement, NkTextInputProps>(
  (
    {
      required = false,
      disabled = false,
      value,
      id,
      testId,
      label,
      placeholder,
      errorMessage,
      onChange,
    }: NkTextInputProps,
    ref,
  ) => {
    return (
      <>
        <NkInputLabel htmlFor={id}>
          {label} {required && '*'}
        </NkInputLabel>
        <StyledInput
          ref={ref}
          type="text"
          id={id}
          data-testid={testId}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          onChange={onChange}
        />
        <NkInputError>{errorMessage}</NkInputError>
      </>
    );
  },
);

const StyledInput = styled('input')<Theme, { disabled?: boolean }>(
  ({ theme, disabled }) => ({
    ...nkInputSize,

    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    color: '#4D4D4D',

    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '3px',
    '&:hover': {
      borderColor: getInputBorderColor(theme, !!disabled, true),
    },
    '&:focus': {
      borderColor: getInputBorderColor(theme, !!disabled, false, true),
      // remove default browser styling
      outline: 'none',
    },
    '&:disabled': {
      backgroundColor: 'initial',
      borderColor: getInputBorderColor(theme, true),
    },
  }),
);
